var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.286133,
    y: 0.553467,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#ADB3C4",
    fillOpacity: 0.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9527 17.6201H8.55272V27.8868H12.9527V17.6201Z",
    fill: "#767A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.486 17.6201H18.0861V27.8868H22.486V17.6201Z",
    fill: "#767A84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9527 30.8201H5.61938V35.2201H34.9527V30.8201Z",
    fill: "#767A84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0194 17.6201H27.6194V27.8868H32.0194V17.6201Z",
    fill: "#767A84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2861 4.4201L5.61938 11.7534V14.6868H34.9527V11.7534L20.2861 4.4201Z",
    fill: "#767A84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeBank);
export default __webpack_public_path__ + "static/media/stripe-bank.7232bcd7fae75c080ff337971d163051.svg";
export { ForwardRef as ReactComponent };